module.exports = " <div class=content> <div class=swiper-container data-space-between=10 data-pagination=.swiper-pagination> <div class=swiper-wrapper> <div v-for=\"slide in slides\" class=swiper-slide> <img :src=slide.img style=\"width: 100%;height:200px\" alt=\"\"> </div> </div> <div class=swiper-pagination></div> </div> <div class=\"bar content_icon\"> <div class=content-block-title>首页应用</div> <div v-for=\"icon in icons\"> <img :src=icon.img class=\"col-20 item_icon\"> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
 ** module id = 16
 ** module chunks = 1
 **/